import {ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
function ToastContainers() {
  return (
    <>
      <ToastContainer  
   position='top-center'
   autoClose={5000}
   hideProgressBar={false}
   newestOnTop={false}
   rtl={false}
   pauseOnFocusLoss
   draggable
   limit={3}
   pauseOnHover
   />
    </>
  )
}

export default ToastContainers
